import React from 'react'

import { useQuizContext } from 'store/QuizStore'
import { setScreen } from 'store/actions'
import { FluidBox } from 'styled'

import {
  Root,
  Content,
  ContentInner,
  Header,
  Body,
  FrostBox,
  Link,
  Copyright,
  IntroButton,
  IntroText,
  HeaderBg,
} from './Intro.styled.js'

import BackgroundSlider from './BackgroundSlider'
import { useBoolean } from 'react-use'

const Intro = () => {
  const { dispatch } = useQuizContext()
  const [ready, toggleReady] = useBoolean(false)
  const [headerBg, toggleHeaderBg] = useBoolean(false)

  return (
    <Root ready={ready}>
      <BackgroundSlider
        onReady={() => toggleReady(true)}
        headerBg={headerBg}
        toggleHeaderBg={toggleHeaderBg}
      ></BackgroundSlider>
      <Content px={[20, 40, 40, 80]} pt={[80, 120, 120, 120]} pb={[40, 40, 40, 80]}>
        <ContentInner>
          <Body>
            <Header pb={[20, 60, 60, 60]}>
              <FluidBox fs="textXl" fw="light">
                Influence your financial future.
              </FluidBox>
              <FluidBox fs="textXl" fw="bold" className="OYW">
                Own your vote
              </FluidBox>
            </Header>
            <IntroText lh={1.56} fs={[16, 18, 18, 18]}>
              Whether you are a proxy voting expert or new to the process, you have the opportunity
              to make your voice heard across a range of topics. Take this interactive quiz to
              explore the ways voting your shares can make a difference and see how you compare to
              fellow investors.
            </IntroText>
          </Body>
          <IntroButton onClick={() => setScreen(dispatch, 'quiz')}>
            <span>TAKE THE INTERACTIVE QUIZ</span>
          </IntroButton>
          <Copyright mt={[40, 80, 80, 80]}>
            <FluidBox fs={12} lh={1.5}>
              © 2021 Broadridge Financial Solutions, Inc. All Rights Reserved.
            </FluidBox>
            <FluidBox fs={12} lh={1.5}>
              <FluidBox
                as="a"
                href="https://www.broadridge.com/legal/privacy-statement-english"
                target="_blank"
                td="underline"
              >
                Privacy Statement
              </FluidBox>
              <span> | </span>
              <FluidBox
                as="a"
                href="https://www.broadridge.com/legal/terms-of-use"
                target="_blank"
                td="underline"
              >
                Terms of Use & Linking Policy
              </FluidBox>
            </FluidBox>
          </Copyright>
        </ContentInner>
      </Content>
      <FrostBox px="spaceNormal" py={[32, 32, 24, 24]}>
        <FluidBox fs="textMedium" mb="spaceNormal" lh={1.33}>
          Discover everything you need to know about proxy voting
        </FluidBox>
        <FluidBox fs="textSmall" mb="spaceXl" lh={1.43}>
          What is a proxy vote? What topics can shareholders vote on? How do you vote? You’ve got
          questions, we’ve got answers.
        </FluidBox>
        <Link
          href="http://shareholdereducation.com/"
          target="_blank"
          fs="textSmall"
          fw="bold"
          className="Link"
        >
          <div>VISIT SHAREHOLDEREDUCATION.COM</div>
        </Link>
      </FrostBox>
      <HeaderBg show={headerBg}></HeaderBg>
    </Root>
  )
}

export default Intro
